export const Loading = () => {
    return <h1>Authentication in progress...</h1>
}